import { checkPropTypes } from 'prop-types';
import React from 'react';
import classes from './index.css'
export default function Certifications(props){

    var btnClass = props.showSect ? classes.btnPressed : classes.btnNotPressed
    return(
        <div 
            className= {classes.btnLvl1 + ' ' + btnClass}
            onClick={props.toggleCerts}
        >
            <h2><span className={classes.btnIcon}><i className="fas fa-award"></i> </span> Certifications </h2>
        </div>
    )
}